// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderCart_container__2zGV1","infoline":"HeaderCart_infoline__FqrUf"};